export default "# Code Walk-through\n\n";